export default "__VITE_ASSET__oq$HVCsN__"